(function () {
  var BREAKPOINT = '(max-width: 989px)';

  function waitForSwiper(cb, tries) {
    if (typeof window.Swiper !== 'undefined') return cb();
    if ((tries || 0) > 60) return;
    setTimeout(function () { waitForSwiper(cb, (tries || 0) + 1); }, 50);
  }

  function syncContainer(container) {
    var swiperEl = container.querySelector('.swiper');
    if (!swiperEl) return;

    var isMobile = window.matchMedia(BREAKPOINT).matches;

    if (isMobile && !swiperEl._cshSwiper) {
      swiperEl._cshSwiper = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        grabCursor: true,
        resistanceRatio: 0.5,
        watchOverflow: true
      });
    } else if (!isMobile && swiperEl._cshSwiper) {
      swiperEl._cshSwiper.destroy(true, true);
      swiperEl._cshSwiper = null;
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var containers = root.querySelectorAll('[data-csh-tabs]');
    containers.forEach(function (container) {
      waitForSwiper(function () { syncContainer(container); });

      if (!container._cshBound) {
        var onResize = function () { waitForSwiper(function () { syncContainer(container); }); };
        window.addEventListener('resize', onResize);
        container._cshBound = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var containers = (e.target || document).querySelectorAll('[data-csh-tabs]');
    containers.forEach(function (container) {
      var swiperEl = container.querySelector('.swiper');
      if (swiperEl && swiperEl._cshSwiper) {
        swiperEl._cshSwiper.destroy(true, true);
        swiperEl._cshSwiper = null;
      }
    });
  });
})();
